import React, { ErrorInfo } from "react";

import Alert from "@amzn/meridian/alert";
import Box from "@amzn/meridian/box";
import Expander from "@amzn/meridian/expander";
import Heading from "@amzn/meridian/heading";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import refreshTokens from "@amzn/meridian-tokens/base/icon/refresh";
import Row from "@amzn/meridian/row";

import { IErrorProps, IErrorState } from "./definitions";

class ErrorBoundary extends React.Component<IErrorProps, IErrorState> {
    readonly exposeError: boolean = process.env.NODE_ENV === "development";
    public state: IErrorState = {
        error: undefined,
        errorInfo: undefined,
    };

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            error,
            errorInfo,
        });
    }

    public render() {
        if (this.state.error) {
            return (
                <Alert type="error">
                    <Row width="100%" widths={["80%", "20%"]}>
                        <Heading level={1} type="h300">
                            Sorry, something went wrong!
                        </Heading>
                        <Button
                            onClick={() => {
                                window.location.reload();
                            }}
                            type="link"
                        >
                            <Icon tokens={refreshTokens} /> Try reload
                        </Button>
                    </Row>

                    <br />
                    {this.exposeError && (
                        <Box>
                            {this.state.error && <Box>{this.state.error.toString()}</Box>}

                            {this.state.errorInfo && (
                                <Expander
                                    title="Details"
                                    type="inline"
                                    open={true}
                                    onChange={() => console.log()}
                                >
                                    <Box>{this.state.errorInfo.componentStack}</Box>
                                </Expander>
                            )}
                        </Box>
                    )}
                </Alert>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
